import { useGetUserProfileQuery } from '@/redux/api/client/userProfile';
import { useAuth } from 'react-oidc-context';

export const useContentOptOut = () => {
  const auth = useAuth();
  const { data: profile, isLoading } = useGetUserProfileQuery(undefined, {
    skip: !auth.isAuthenticated
  });
  return {
    contentOptOut: profile?.contentOptOut ?? [],
    isLoading
  };
};
